import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import { Seo } from '../components/Seo';
import { Icon } from '../components/ui/Icon';

export default function NotFoundPage() {
  return (
    <>
      <Seo
        title="Page introuvable"
        description="Cette page n’existe pas. Retourne au comparatif ou à la liste d’offres."
        canonicalPath="/404"
        noIndex
      />
      <section className="lbf-container py-16">
        <div className="lbf-card p-6">
          <div className="text-3xl font-black text-white">404</div>
          <p className="mt-3 text-sm text-zinc-200/85">
            Mauvais lien ou page supprimée. Le plus simple: repartir du comparatif.
          </p>
          <div className="mt-6 flex flex-col gap-2 sm:flex-row">
            <NavLink to="/comparatif-offres" className="lbf-btn-primary">
              Comparatif <Icon icon={FiArrowRight} aria-hidden="true" />
            </NavLink>
            <NavLink to="/offres" className="lbf-btn-ghost">
              Offres & avis
            </NavLink>
          </div>
        </div>
      </section>
    </>
  );
}


